import { VARIANTSFILTER_RECIVE } from '../../Rutab/RutabConstants';

const defaultState = {
    variants: {
        variantFilterOptions: [],
        variantInformationTitles: [],
        variants: []
    },
};

export const variantFilter = (state = defaultState, action) => {
    switch (action.type) {
        case VARIANTSFILTER_RECIVE:
            return {
                ...state,              
                ...action.payload,
            };
        default:
            return state;
    }
};